module.exports = __webpack_public_path__ + "img/logo.a743875b.svg";